(function () {
  let postsSwiper;

  const initSlider = (slider) => {
    // COY: idempotent guard so a deterministic on-load init can't double-run with the observer.
    if (!slider || slider.classList.contains("swiper-initialized") || slider.swiper) return;

    slider.classList.add("swiper");

    const wrapper = slider.querySelector(".blog-posts-grid");

    if (!wrapper) return;

    wrapper.classList.add("swiper-wrapper");

    const slides = slider.querySelectorAll(".blog-posts-card");

    if (!slides || !slides.length) return;

    slides.forEach((slide) => {
      slide.classList.add("swiper-slide");
    });

    const nextBtn = slider.querySelector(".blog-posts-nav-button--next");
    const prevBtn = slider.querySelector(".blog-posts-nav-button--prev");

    const spaceBetween = slider.classList.contains(
      "swiper--blog-posts--visible-overflow"
    )
      ? 16
      : 16; //20;

    const slidesPerView = slider.classList.contains(
      "swiper--blog-posts--visible-overflow"
    )
      ? "auto"
      :  1.1; //1;

    const breakpoints = {
        767: {
          slidesPerView: 2.1
        },
        900: {
          slidesPerView: 3.1
        },
        1441: {
          slidesPerView: 4.1
        },
      };

    postsSwiper = new Swiper(slider, {
      loop: false,
      slidesPerView: slidesPerView,
      spaceBetween: spaceBetween,
      speed: 1000,
      allowTouchMove: true,
      // COY: enable desktop trackpad / mousewheel horizontal swipe, same as the product
      // recommendations slider. forceToAxis:true → only horizontal-intent gestures move the
      // carousel; vertical scroll still scrolls the page.
      mousewheel: { forceToAxis: true },
      // GEO/agentic: the slides are <li> inside a <ul>. Swiper's a11y default overrides each
      // slide's role to "group", which is an invalid ARIA role for an <li> and breaks the
      // accessibility tree that AI agents read (PageSpeed "Agentic" check). Keep the appropriate
      // "listitem" role so the tree stays well-formed. No visual/behaviour change.
      a11y: {
        slideRole: "listitem",
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "blog-posts-nav-button--disabled",
      },
      breakpoints: breakpoints,
    });
  };

  const destroySlider = (section) => {
    if (!section || !section?.classList.contains("section-blog-posts")) return;

    const slider = section.querySelector(".swiper--blog-posts");
    const slides = section.querySelectorAll(".blog-posts-card");
    const wrapper = section.querySelector(".blog-posts-grid");

    if (!slider || !slides || !slides.length || !wrapper) return;

    slider.classList.remove("swiper");

    slides.forEach((slide) => {
      slide.removeAttribute("style");
      slide.classList.remove("swiper-slide");
    });

    wrapper.classList.remove("swiper-wrapper");

    postsSwiper.destroy(true, true);
    postsSwiper = null;
  };

  const initBlogPosts = (section) => {
    if (!section || !section?.classList.contains("section-blog-posts")) return;

    const slider = section.querySelector(".swiper--blog-posts");

    if (!slider) return;

    const sectionResizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (slider) {
          initSlider(slider);
        } else if (postsSwiper) {
          destroySlider(section);
        }
      });
    });

    sectionResizeObserver.observe(section);


    const slider1 = section.querySelector(".swiper--blog-posts--1");

    if (!slider1) return;

    const sectionResizeObserver1 = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (slider1) {
          initSlider(slider1);
        } else if (postsSwiper) {
          destroySlider(section);
        }
      });
    });

    sectionResizeObserver1.observe(section);

    const slider2 = section.querySelector(".swiper--blog-posts--2");

    if (!slider2) return;

    const sectionResizeObserver2 = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (slider2) {
          initSlider(slider2);
        } else if (postsSwiper) {
          destroySlider(section);
        }
      });
    });

    sectionResizeObserver2.observe(section);

    const slider3 = section.querySelector(".swiper--blog-posts--3");

    if (!slider3) return;

    const sectionResizeObserver3 = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (slider3) {
          initSlider(slider3);
        } else if (postsSwiper) {
          destroySlider(section);
        }
      });
    });

    sectionResizeObserver3.observe(section);
  };

  const animateBlogPostCards = (section) => {
    if (
      !section ||
      !section?.classList.contains("section-blog-posts") ||
      !section.querySelector(".animate-on-scroll")
    ) {
      return;
    }

    // COY: was `querySelector` — FIRST container only. Multi-row blogs (the magazine's Recent
    // Articles renders 6-card rows as sibling .blog-posts-container elements) left rows 2+
    // without a ScrollTrigger, so their cards kept the pre-reveal translateY(20%) forever:
    // a permanently bigger visual gap above row 2 (row 1 settled, row 2 shifted ~60px down)
    // while row 2 -> row 3 looked normal (both shifted equally). Wire EVERY row container so
    // each row reveals like the first and the settled row gaps are uniform.
    const blogPostsContainers = section.querySelectorAll(".blog-posts-container");

    if (!blogPostsContainers.length) return;

    // COY Reveal (Stage 0 of the unification): the shared observer in assets/coy-reveal.js
    // owns the whole lifecycle — reveal once on first intersection (immediately when already
    // in viewport at load), settle + unobserve; containers inside a [data-reveal-replay]
    // section reset on genuine FULL viewport exit and replay on return. Trigger geometry
    // parity with the previous ScrollTrigger wiring ("top 95%" mobile / "top 90%" desktop)
    // is preserved by the utility's default rootMargins. This section no longer uses
    // ScrollTrigger for reveals.
    if (window.CoyReveal) {
      blogPostsContainers.forEach((c) => window.CoyReveal.observe(c));
    } else {
      // Utility missing (script blocked/failed): never leave content hidden — settle
      // immediately with no animation. Content renders; animation is enhancement only.
      blogPostsContainers.forEach((c) => c.classList.add("animated"));
    }
  };

  if (postsSwiper) {
    destroySlider(document.currentScript.parentElement);
  }

  initBlogPosts(document.currentScript.parentElement);
  animateBlogPostCards(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (e) {
    if (postsSwiper) {
      destroySlider(e.target);
    }

    initBlogPosts(e.target);
    animateBlogPostCards(e.target);
  });

  // COY: initBlogPosts inits the slider only via a racy ResizeObserver first-fire that
  // intermittently never completes (confirmed live: init:false on fresh loads), leaving the
  // cards as a static grid. Deterministically init every blog-posts slider on load as a
  // guaranteed fallback (initSlider is idempotent, so it won't double-init with the observer).
  var coyInitAllBlogSliders = function () {
    if (typeof Swiper !== "function") return;
    document
      .querySelectorAll(".section-blog-posts .swiper--blog-posts")
      .forEach(function (sl) {
        initSlider(sl);
      });
  };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", coyInitAllBlogSliders);
  } else {
    coyInitAllBlogSliders();
  }
  window.addEventListener("load", coyInitAllBlogSliders);
})();